/* eslint-disable */
import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import moment from "moment";
import { isMobile, isTablet } from "react-device-detect";

function Allocate() {
  const [list, setlist] = useState([]);
  const [tradeList, settradeList] = useState([]);
  const [leaseList, setleaseList] = useState([]);
  const [entitlementList, setEntitlementList] = useState([]);
  const [forwardsList, setForwardsList] = useState([]);
  const [optionsList, setOptionsList] = useState([]);
  const [query, setquery] = useState("");
  const [catquery, setcatquery] = useState("Allocation Markets");
  const [timeStampAllocate, setTimeStampAllocate] = useState("");

  const instrumentsToGroup = {
    "1A": "1A Goulburn",
    "1B": "1A Goulburn",
    3: "1A Goulburn",
    "4A": "1A Goulburn",
    "5A": "1A Goulburn",
    6: "6 Murray",
    "6B": "7 Murray",
    7: "7 Murray",
    "7GMW": "7 Murray",
    "7LMW": "7 Murray",
    10: "10 Murray",
    "10MIL": "10 Murray",
    11: "11 Murray",
    "11WMI": "11 Murray",
    12: "12 SA",
    "12CIT": "12 SA",
    "12RIT": "12 SA",
    13: "13M'bidgee",
    "13CICL": "13M'bidgee",
    "13MIA": "13M'bidgee",
  };

  // Parse YYYY-MM-DDTHH:mm:ss as UTC
  function parseUTC(s) {
    var b = s.split(/\D/);
    return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5]));
  }

  useEffect(() => {
    function getGroup(instrument) {
      let group = instrumentsToGroup[instrument];
      if (group == null || group.length < 1) {
        group = instrument;
      }
      return group;
    }
    // refactor using async await tamnguyen
    function fetchAPI() {
      const requestPricingAPI = "/wp-json/xpansiv/v1/pricingData/";
      const requestTradeAPI = "/wp-json/xpansiv/v1/tradingData/";
      const leaseAPI =
        "https://sheets.googleapis.com/v4/spreadsheets/1DfxDbieoCcAEiu1AggAmpUAYsDjOS9ksahhUInop-JU/values/Listings%20-%20Leases?alt=json&key=AIzaSyA_U3h3W_rR5Yr-US7C-yTzx02evV9ntk4";
      const forwardAPI =
        "https://sheets.googleapis.com/v4/spreadsheets/1DfxDbieoCcAEiu1AggAmpUAYsDjOS9ksahhUInop-JU/values/Listings%20-%20Forwards?alt=json&key=AIzaSyA_U3h3W_rR5Yr-US7C-yTzx02evV9ntk4";
      const entitlementAPI =
        "https://sheets.googleapis.com/v4/spreadsheets/1DfxDbieoCcAEiu1AggAmpUAYsDjOS9ksahhUInop-JU/values/Listings%20-%20Entitlement?alt=json&key=AIzaSyA_U3h3W_rR5Yr-US7C-yTzx02evV9ntk4";
      const optionAPI =
        "https://sheets.googleapis.com/v4/spreadsheets/1DfxDbieoCcAEiu1AggAmpUAYsDjOS9ksahhUInop-JU/values/Listings%20-%20Options?alt=json&key=AIzaSyA_U3h3W_rR5Yr-US7C-yTzx02evV9ntk4";

      fetch(requestPricingAPI)
        .then((response) => response.json())
        .then((responseData) => {
          let { data } = responseData.result;

          for (let i = 0; i < data.length; i++) {
            let group = getGroup(data[i].instrument);
            data[i].group = group;
          }

          data = data.sort((a, b) => {
            let comp = 0;
            if (b.group < a.group) {
              comp = 1;
            } else if (b.group > a.group) {
              comp = -1;
            }
            return comp;
          });
          setlist(data);

          console.log("responseData:", responseData);
          let timeStampAllocate =
            responseData.result.update_timestamp.toString();

          let utcTimeZone = timeStampAllocate.replace("T", " ") + " UTC";
          let convertedToLocalTime = new Date(utcTimeZone);

          if (parseUTC(timeStampAllocate) !== "Invalid Date") {
            let d = parseUTC(timeStampAllocate);
            setTimeStampAllocate(d.toString());
          } else if (isNaN(Date.parse(convertedToLocalTime))) {
            let localTimeZone = moment.utc(timeStampAllocate).toDate();

            if (localTimeZone || localTimeZone !== "Invalid Date") {
              setTimeStampAllocate(localTimeZone.toString());
            } else {
              let AEDTTimeZone = timeStampAllocate + "+11:00";
              let convertedAEDTTimeZone =
                moment().utcOffset(AEDTTimeZone).format("YYYY-MM-DD HH:mm:ss") +
                " (AEDT Time Zone)";

              setTimeStampAllocate(convertedAEDTTimeZone);
            }
          }
        })
        .catch((err) => console.log("error", err));

      fetch(requestTradeAPI)
        .then((response) => response.json())
        .then((responseData) => {
          let { data } = responseData;
          for (let i = 0; i < data.length; i++) {
            let group = getGroup(data[i].instrument);
            data[i].group = group;
          }
          data = data.sort((a, b) => {
            let comp = 0;
            if (Date.parse(a.timestamp) < Date.parse(b.timestamp)) {
              comp = 1;
            } else if (Date.parse(a.timestamp) > Date.parse(b.timestamp)) {
              comp = -1;
            }
            return comp;
          });
          settradeList(data);
        })
        .catch((err) => console.log("error", err));

      fetch(entitlementAPI)
        .then((response) => response.json())
        .then((responseData) => {
          const { values } = responseData;
          values.shift();
          //const {feed} = responseData;
          //const {entry} = feed;
          console.log(JSON.stringify(values));
          setEntitlementList(values);
        })
        .catch((err) => console.log("error", err));

      fetch(forwardAPI)
        .then((response) => response.json())
        .then((responseData) => {
          const { values } = responseData;
          //const {entry} = feed;
          values.shift();
          setForwardsList(values);
        })
        .catch((err) => console.log("error", err));

      fetch(leaseAPI)
        .then((response) => response.json())
        .then((responseData) => {
          const { values } = responseData;
          values.shift();
          //const {entry} = feed;
          setleaseList(values);
        })
        .catch((err) => console.log("error", err));

      fetch(optionAPI)
        .then((response) => response.json())
        .then((responseData) => {
          const { values } = responseData;
          values.shift();
          //const {entry} = feed;
          setOptionsList(values);
        })
        .catch((err) => console.log("error", err));
    }
    fetchAPI();
  }, []);

  function searchAllocation(rows) {
    console.log(rows);
    return rows.filter((row) => {
      console.log(row);
      return (
        row.instrument.toString().toLowerCase().indexOf(query.toLowerCase()) >
          -1 ||
        row.group.toString().toLowerCase().indexOf(query.toLowerCase()) > -1
      );
    });
  }

  function searchGoogle(rows) {
    //console.log(query)
    if (query.length == 0) {
      return rows;
    }
    //console.log(`before ${rows.length}`)
    const filteredRows = rows.filter((row) => {
      //console.log(row)
      return row.map((r) => r.toLowerCase()).includes(query.toLowerCase());
    });
    //console.log(`after ${filteredRows.length}`)
    return filteredRows;
  }

  const category = () => {
    return [...new Set(list.map((item) => item.InstrumentGroup))];
  };

  function getUniqueItemList(currentList) {
    let set = new Set(currentList.map((item) => item.group));
    let list = Array.from(set);
    console.log(list);
    return list;
  }

  function getItemLargestValue(value, status) {
    let temp = [];

    for (let i = 0; i < list.length; i++) {
      if (list[i].group === value && list[i].side === status) {
        temp.push(list[i].price);
      }
    }
    return temp.length > 0 ? Math.max(...temp) : "-";
  }
  function getItemSmallestValue(value, status) {
    let highest = 0;
    let temp = [];

    for (let i = 0; i < list.length; i++) {
      if (list[i].group === value && list[i].side === status) {
        temp.push(list[i].price);
      }
    }
    return temp.length > 0 ? Math.min(...temp) : "-";
  }
  function getItemFilter(value, status) {
    for (let i = 0; i < list.length; i++) {
      if (list[i].group === value && list[i].side === status) {
        return "$" + list[i].price;
      }
    }
    return "-";
  }

  function getLastPrice(value) {
    for (let i = 0; i < tradeList.length; i++) {
      if (tradeList[i].group === value) {
        return "$" + tradeList[i].price;
      }
    }
    return "-";
  }

  const filterSectionByListElm = document.querySelector(
    ".filter-by-section-list-allocate"
  );
  const optionWrapperOverlayElm = document.querySelector(
    ".optionWrapperOverlay"
  );

  const handleOpenSelect = () => {
    if (filterSectionByListElm.style.display != "none") {
      filterSectionByListElm.style.display = "none";
      //optionWrapperOverlayElm.style.display = 'none'
    } else {
      filterSectionByListElm.style.display = "block";
      //optionWrapperOverlayElm.style.display = 'block'
    }
  };

  const handleOverlay = (e) => {
    const currentValue = e.target.value;

    setTimeout(() => {
      const categoryItemListElm = document.querySelectorAll(
        ".category-item-list-allocate"
      );

      for (let i = 0; i < categoryItemListElm.length; i++) {
        if (categoryItemListElm[i].value.toString() === currentValue) {
          categoryItemListElm[i].classList.add("selectionOptionbtnSelected");
        }
      }

      if (filterSectionByListElm.style.display != "none") {
        filterSectionByListElm.style.display = "none";
        //optionWrapperOverlayElm.style.display = 'none'
      } else {
        filterSectionByListElm.style.display = "block";
        //optionWrapperOverlayElm.style.display = 'block'
      }
    }, 50);
  };

  const handleToggle = (e) => {
    const itemListElm = e.target.closest(
      ".plm-item-detail-wrapper"
    ).nextSibling;

    if (itemListElm) {
      if (itemListElm.style.display === "none") {
        itemListElm.style.display = "block";
        e.target.innerHTML = "-";
      } else {
        itemListElm.style.display = "none";
        e.target.innerHTML = "+";
      }
    }
  };

  const getTable = (mobile) => {
    if (catquery === "Allocation Markets") {
      if (mobile) {
        return allocationMobileTable();
      } else return allocationDesktopTable();
    } else if (catquery === "Entitlements") {
      if (mobile) return entitlementMobileTable();
      else return entitlementsDesktopTable();
    } else if (catquery === "Forwards") {
      if (mobile) return forwardsMobileTable();
      else return forwardsDesktopTable();
    } else if (catquery === "Leases") {
      if (mobile) return leaseMobileTable();
      else return leaseDesktopTable();
    } else if (catquery === "Options") {
      if (mobile) return optionsMobileTable();
      else return optionsDesktopTable();
    }
  };

  if (isMobile && !isTablet) {
    const styles = {
      // 'backgroundColor': '',
      // 'bladeHeight': '',
    };
    //console.log(styles.bladeHeight)
    return (
      <div
        style={{
          height: styles.bladeHeight,
          backgroundColor: styles.backgroundColor,
        }}
      >
        <span className="pricing-sub-title">PRICING</span>
        { /* {allocationMobileTable()} */ }
        <div className="product-search-section">
          <div className="col">{getSelector()}</div>
          <div className="col">
            <div className="filter-list">
              <input
                placeholder={"Filter " + catquery}
                className="__xsv_filter-search"
                value={query}
                onChange={(e) => {
                  setquery(e.target.value);
                }}
              />
            </div>
          </div>
        </div>

        {getTable(true)}
      </div>
    );
  } else {
    const styles = {
      // 'backgroundColor': '<?php echo $instance['color']; ?>',
      // 'bladeHeight': '<?php echo $instance['bladeHeight']; ?>',
    };
    //console.log(styles.bladeHeight)
    return (
      <div
        style={{
          height: styles.bladeHeight,
          backgroundColor: styles.backgroundColor,
        }}
      >
        <span className="sub-title">PRICING</span>
        { /* {allocationDesktopTable()} */ }
        <div className="product-search-section row">
          <div className="col">{getSelector()}</div>
          <div className="col">
            <div className="filter-list">
              <input
                placeholder={"Filter " + catquery}
                className="__xsv_filter-search"
                value={query}
                onChange={(e) => {
                  setquery(e.target.value);
                }}
              />
            </div>
          </div>
        </div>
        {getTable(false)}
      </div>
    );
  }

  function getSelector() {
    return (
      <div className="selectiveOption">
        <div className="selectiveOption-inner">
          <div onClick={handleOpenSelect} className="product-search-category">
            {catquery}
          </div>
        </div>

        <div className="rt-tpg-container">
          <div className="filter-by-section-text"></div>
          <div
            className="rt-tpg-isotope-buttons filter-button-group option-set filter-by-section-list-allocate __xps-select-option-wrapper"
            style={{ display: "none" }}
          >
            <div className="__xps-select-option-inner">
              <button
                key={uuidv4()}
                className="category-item-list-allocate"
                value="Allocation Markets"
                onClick={(e) => {
                  setcatquery(e.target.value);
                  setquery("");
                  handleOverlay(e);
                }}
              >
                Allocation Markets
              </button>

              <button
                key={uuidv4()}
                className="category-item-list-allocate"
                value="Entitlements"
                onClick={(e) => {
                  setcatquery(e.target.value);
                  setquery("");
                  handleOverlay(e);
                }}
              >
                Entitlements
              </button>

              <button
                key={uuidv4()}
                className="category-item-list-allocate"
                value="Forwards"
                onClick={(e) => {
                  setcatquery(e.target.value);
                  setquery("");
                  handleOverlay(e);
                }}
              >
                Forwards
              </button>

              <button
                key={uuidv4()}
                className="category-item-list-allocate"
                value="Leases"
                onClick={(e) => {
                  setcatquery(e.target.value);
                  setquery("");
                  handleOverlay(e);
                }}
              >
                Leases
              </button>

              <button
                key={uuidv4()}
                className="category-item-list-allocate"
                value="Options"
                onClick={(e) => {
                  setcatquery(e.target.value);
                  setquery("");
                  handleOverlay(e);
                }}
              >
                Options
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  function entitlementsDesktopTable() {
    return (
      <div className="table table-light pb-4">
        <div className="table--columns">
          <div>Side</div>
          <div>Zone</div>
          <div>Class</div>
          <div>Volume (ML)</div>
          <div>Price</div>
          <div>Comment</div>
        </div>
        {
          //list.length > 0 &&
          searchGoogle(entitlementList).map((item, id) => {
            return (
              <div className="table--row" key={uuidv4()}>
                <div>{item[0]}</div>
                <div>{item[1]}</div>
                <div>{item[2]}</div>
                <div>{item[3]}</div>
                <div className="h2o-text-bid">{item[4]}</div>
                <div>{item[5]}</div>
              </div>
            );
          })
        }
      </div>
    );
  }

  function leaseDesktopTable() {
    return (
      <div className="table table-light pb-4">
        <div className="table--columns">
          <div>Side</div>
          <div>Zone</div>
          <div>Class</div>
          <div>Volume (ML)</div>
          <div>Start Date</div>
          <div>Period</div>
          <div>Price</div>
          <div>Comment</div>
        </div>
        {list.length > 0 &&
          searchGoogle(leaseList).map((item, id) => {
            return (
              <div className="table--row" key={uuidv4()}>
                <div>{item[0]}</div>
                <div>{item[1]}</div>
                <div>{item[2]}</div>
                <div>{item[3]}</div>
                <div>{item[4]}</div>
                <div>{item[5]}</div>
                <div className="h2o-text-bid">{item[6]}</div>
                <div>{item[7]}</div>
              </div>
            );
          })}
      </div>
    );
  }

  function optionsDesktopTable() {
    return (
      <div className="table table-light pb-4">
        <div className="table--columns">
          <div>Side</div>
          <div>Zone</div>
          <div>Volume (ML)</div>
          <div>Delivery</div>
          <div>Premium</div>
          <div>Excercise</div>
          <div>Comment</div>
        </div>
        {list.length > 0 &&
          searchGoogle(optionsList).map((item, id) => {
            return (
              <div className="table--row" key={uuidv4()}>
                <div>{item[0]}</div>
                <div>{item[1]}</div>
                <div>{item[2]}</div>
                <div>{item[3]}</div>
                <div className="h2o-text-bid">{item[4]}</div>
                <div className="h2o-text-bid">{item[5]}</div>
                <div>{item[6]}</div>
              </div>
            );
          })}
      </div>
    );
  }
  function forwardsDesktopTable() {
    return (
      <div className="table table-light pb-4">
        <div className="table--columns">
          <div>Side</div>
          <div>Zone</div>
          <div>Volume (ML)</div>
          <div>Delivery</div>
          <div>Price</div>
          <div>Comment</div>
        </div>
        {list.length > 0 &&
          searchGoogle(forwardsList).map((item, id) => {
            return (
              <div className="table--row" key={uuidv4()}>
                <div>{item[0]}</div>
                <div>{item[1]}</div>
                <div>{item[2]}</div>
                <div>{item[3]}</div>
                <div className="h2o-text-bid">{item[4]}</div>
                <div>{item[5]}</div>
              </div>
            );
          })}
      </div>
    );
  }

  function allocationDesktopTable() {
    return (
      <div>
        <div className="table table-light pb-4">
          <div className="table--columns">
            <div>Market</div>
            <div>Bid</div>
            <div>Offer</div>
            <div>Last</div>
          </div>

          {list.length > 0 &&
            getUniqueItemList(searchAllocation(list)).map(
              (itemInstrument, id) => {
                console.log("itemInstrument:", itemInstrument);

                return (
                  <div className="table--row" key={uuidv4()}>
                    <div>
                      <a href={"/allocation-details/#" + itemInstrument}>
                        {itemInstrument}
                      </a>
                    </div>
                    <div className="h2o-text-bid">
                      {getItemLargestValue(itemInstrument, "B")}
                    </div>
                    <div className="text-danger">
                      {getItemSmallestValue(itemInstrument, "S")}
                    </div>
                    <div className="h2o-text-bid">
                      {getLastPrice(itemInstrument)}
                    </div>
                  </div>
                );
              }
            )}
        </div>
        {timeStampAllocate && (
          <span
            className="allocation-detail-dislaimer"
            style={{
              color: "white",
            }}
          >
            Last updated {timeStampAllocate}
          </span>
        )}
      </div>
    );
  }

  function allocationMobileTable() {
    return (
      <div className="product-list-main">
        <div className="plm-item-title">
          <label>Market</label>
        </div>
        {searchAllocation(list).length > 0 ? (
          <div className="plm-item-wrapper" key={uuidv4()}>
            <div className="plm-item-detail-wrapper">
              <div className="plm-item-detail-name">
                {getUniqueItemList(searchAllocation(list))[0]}
              </div>
              <div
                className="plm-item-detail-name allocate-mobile-item-detail-icon font-weight-bold"
                onClick={(e) => handleToggle(e)}
              >
                -
              </div>
            </div>
            <div className="plm-item-detail-outer-wrapper">
              <div className="plm-item-detail-wrapper">
                <div className="plm-item-detail-name circular-bold">Bid</div>
                <div className="plm-item-detail-name h2o-text-bid ">
                  {getItemLargestValue(
                    getUniqueItemList(searchAllocation(list))[0],
                    "B"
                  )}
                </div>
              </div>
              <div className="plm-item-detail-wrapper">
                <div className="plm-item-detail-name circular-bold">Offer</div>
                <div className="plm-item-detail-name text-danger circular-bold">
                  {getItemSmallestValue(
                    getUniqueItemList(searchAllocation(list))[0],
                    "S"
                  )}
                </div>
              </div>
              <div className="plm-item-detail-wrapper">
                <div className="plm-item-detail-name circular-bold">Last</div>
                <div className="plm-item-detail-name h2o-text-bid ">
                  {getLastPrice(getUniqueItemList(searchAllocation(list))[0])}
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}

        {list.length > 0 &&
          getUniqueItemList(searchAllocation(list))
            .slice(1)
            .map((itemInstrument, id) => {
              return (
                <div className="plm-item-wrapper" key={uuidv4()}>
                  <div className="plm-item-detail-wrapper">
                    <div className="plm-item-detail-name">{itemInstrument}</div>
                    <div
                      className="plm-item-detail-name allocate-mobile-item-detail-icon font-weight-bold"
                      onClick={(e) => handleToggle(e)}
                    >
                      +
                    </div>
                  </div>
                  <div
                    className="plm-item-detail-outer-wrapper"
                    style={{ display: "none" }}
                  >
                    <div className="plm-item-detail-wrapper">
                      <div className="plm-item-detail-name circular-bold">
                        Bid
                      </div>
                      <div className="plm-item-detail-name h2o-text-bid ">
                        {getItemLargestValue(itemInstrument, "B")}
                      </div>
                    </div>
                    <div className="plm-item-detail-wrapper">
                      <div className="plm-item-detail-name circular-bold">
                        Offer
                      </div>
                      <div className="plm-item-detail-name text-danger font-weight-bold">
                        {getItemSmallestValue(itemInstrument, "S")}
                      </div>
                    </div>
                    <div className="plm-item-detail-wrapper">
                      <div className="plm-item-detail-name circular-bold">
                        Last
                      </div>
                      <div className="plm-item-detail-name h2o-text-bid">
                        {getLastPrice(itemInstrument)}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        <span className="allocation-detail-dislaimer">
          Last updated {timeStampAllocate}
        </span>
      </div>
    );
  }

  function entitlementMobileTable() {
    //console.log(searchGoogle(entitlementList));

    return (
      <div className="product-list-main">
        <div className="plm-item-title">
          <label className="font-weight-bold">Zone</label>
        </div>
        {searchGoogle(entitlementList).length > 0 ? (
          <div className="plm-item-wrapper" key={uuidv4()}>
            <div className="plm-item-detail-wrapper">
              <div className="plm-item-detail-name">
                {searchGoogle(entitlementList)[0][1]}
              </div>
              <div
                className="plm-item-detail-name allocate-mobile-item-detail-icon circular-bold"
                onClick={(e) => handleToggle(e)}
              >
                -
              </div>
            </div>
            <div className="plm-item-detail-outer-wrapper">
              <div className="plm-item-detail-wrapper">
                <div className="plm-item-detail-name circular-bold">Side</div>
                <div className="plm-item-detail-name circular-bold">
                  {searchGoogle(entitlementList)[0][0]}
                </div>
              </div>
              <div className="plm-item-detail-wrapper">
                <div className="plm-item-detail-name circular-bold">Class</div>
                <div className="plm-item-detail-name circular-bold">
                  {searchGoogle(entitlementList)[0][2]}
                </div>
              </div>
              <div className="plm-item-detail-wrapper">
                <div className="plm-item-detail-name circular-bold">
                  Volume (ML)
                </div>
                <div className="plm-item-detail-name circular-bold">
                  {searchGoogle(entitlementList)[0][3]}
                </div>
              </div>
              <div className="plm-item-detail-wrapper">
                <div className="plm-item-detail-name circular-bold">Price</div>
                <div className="plm-item-detail-name h2o-text-bid circular-bold">
                  {searchGoogle(entitlementList)[0][4]}
                </div>
              </div>
              <div className="plm-item-detail-wrapper">
                <div className="plm-item-detail-name circular-bold">
                  Comment
                </div>
                <div className="plm-item-detail-name circular-bold">
                  {searchGoogle(entitlementList)[0][5]}
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}

        {searchGoogle(entitlementList).length > 1 &&
          searchGoogle(entitlementList)
            .slice(1)
            .map((item, id) => {
              return (
                <div className="plm-item-wrapper" key={uuidv4()}>
                  <div className="plm-item-detail-wrapper">
                    <div className="plm-item-detail-name">{item[1]}</div>
                    <div
                      className="plm-item-detail-name allocate-mobile-item-detail-icon font-weight-bold"
                      onClick={(e) => handleToggle(e)}
                    >
                      +
                    </div>
                  </div>
                  <div
                    className="plm-item-detail-outer-wrapper"
                    style={{ display: "none" }}
                  >
                    <div className="plm-item-detail-wrapper">
                      <div className="plm-item-detail-name circular-bold">
                        Side
                      </div>
                      <div className="plm-item-detail-name circular-bold">
                        {item[0]}
                      </div>
                    </div>
                    <div className="plm-item-detail-wrapper">
                      <div className="plm-item-detail-name circular-bold">
                        Class
                      </div>
                      <div className="plm-item-detail-name circular-bold">
                        {item[2]}
                      </div>
                    </div>
                    <div className="plm-item-detail-wrapper">
                      <div className="plm-item-detail-name circular-bold">
                        Volume (ML)
                      </div>
                      <div className="plm-item-detail-name circular-bold">
                        {item[3]}
                      </div>
                    </div>
                    <div className="plm-item-detail-wrapper">
                      <div className="plm-item-detail-name circular-bold">
                        Price
                      </div>
                      <div className="plm-item-detail-name h2o-text-bid circular-bold">
                        {item[4]}
                      </div>
                    </div>
                    <div className="plm-item-detail-wrapper">
                      <div className="plm-item-detail-name circular-bold">
                        Comment
                      </div>
                      <div className="plm-item-detail-name circular-bold">
                        {item[5]}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
      </div>
    );
  }

  function leaseMobileTable() {
    // console.log(searchGoogle(leaseList));
    return (
      <div className="product-list-main">
        <div className="plm-item-title">
          <label className="font-weight-bold">Zone</label>
        </div>

        {searchGoogle(leaseList).length > 0 ? (
          <div className="plm-item-wrapper" key={uuidv4()}>
            <div className="plm-item-detail-wrapper">
              <div className="plm-item-detail-name">
                {searchGoogle(leaseList)[0][1]}
              </div>
              <div
                className="plm-item-detail-name allocate-mobile-item-detail-icon font-weight-bold "
                onClick={(e) => handleToggle(e)}
              >
                -
              </div>
            </div>
            <div className="plm-item-detail-outer-wrapper">
              <div className="plm-item-detail-wrapper">
                <div className="plm-item-detail-name circular-bold">Side</div>
                <div className="plm-item-detail-name circular-bold">
                  {searchGoogle(leaseList)[0][0]}
                </div>
              </div>
              <div className="plm-item-detail-wrapper">
                <div className="plm-item-detail-name circular-bold">Class</div>
                <div className="plm-item-detail-name circular-bold">
                  {searchGoogle(leaseList)[0][2]}
                </div>
              </div>
              <div className="plm-item-detail-wrapper">
                <div className="plm-item-detail-name circular-bold">
                  Volume (ML)
                </div>
                <div className="plm-item-detail-name circular-bold">
                  {searchGoogle(leaseList)[0][3]}
                </div>
              </div>
              <div className="plm-item-detail-wrapper">
                <div className="plm-item-detail-name circular-bold">
                  Start Date
                </div>
                <div className="plm-item-detail-name circular-bold">
                  {searchGoogle(leaseList)[0][4]}
                </div>
              </div>
              <div className="plm-item-detail-wrapper">
                <div className="plm-item-detail-name circular-bold">Period</div>
                <div className="plm-item-detail-name circular-bold">
                  {searchGoogle(leaseList)[0][5]}
                </div>
              </div>
              <div className="plm-item-detail-wrapper">
                <div className="plm-item-detail-name circular-bold">Price</div>
                <div className="plm-item-detail-name h2o-text-bid circular-bold">
                  {searchGoogle(leaseList)[0][6]}
                </div>
              </div>
              <div className="plm-item-detail-wrapper">
                <div className="plm-item-detail-name circular-bold">
                  Comment
                </div>
                <div className="plm-item-detail-name circular-bold">
                  {searchGoogle(leaseList)[0][7]}
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}

        {searchGoogle(leaseList).length > 1 &&
          searchGoogle(leaseList)
            .slice(1)
            .map((item, id) => {
              // console.log("searchGoogle(leaseList).length > 1");
              return (
                <div className="plm-item-wrapper" key={uuidv4()}>
                  <div className="plm-item-detail-wrapper">
                    <div className="plm-item-detail-name">{item[1]}</div>
                    <div
                      className="plm-item-detail-name allocate-mobile-item-detail-icon font-weight-bold"
                      onClick={(e) => handleToggle(e)}
                    >
                      +
                    </div>
                  </div>
                  <div
                    className="plm-item-detail-outer-wrapper"
                    style={{ display: "none" }}
                  >
                    <div className="plm-item-detail-wrapper">
                      <div className="plm-item-detail-name circular-bold">
                        Side
                      </div>
                      <div className="plm-item-detail-name circular-bold">
                        {item[0]}
                      </div>
                    </div>
                    <div className="plm-item-detail-wrapper">
                      <div className="plm-item-detail-name circular-bold">
                        Class
                      </div>
                      <div className="plm-item-detail-name circular-bold">
                        {item[2]}
                      </div>
                    </div>
                    <div className="plm-item-detail-wrapper">
                      <div className="plm-item-detail-name circular-bold">
                        Volume (ML)
                      </div>
                      <div className="plm-item-detail-name font-weight-bold">
                        {item[3]}
                      </div>
                    </div>
                    <div className="plm-item-detail-wrapper">
                      <div className="plm-item-detail-name circular-bold">
                        Start Date
                      </div>
                      <div className="plm-item-detail-name circular-bold">
                        {item[4]}
                      </div>
                    </div>
                    <div className="plm-item-detail-wrapper">
                      <div className="plm-item-detail-name circular-bold">
                        Period
                      </div>
                      <div className="plm-item-detail-name circular-bold">
                        {item[5]}
                      </div>
                    </div>
                    <div className="plm-item-detail-wrapper">
                      <div className="plm-item-detail-name circular-bold">
                        Price
                      </div>
                      <div className="plm-item-detail-name h2o-text-bid circular-bold">
                        {item[6]}
                      </div>
                    </div>
                    <div className="plm-item-detail-wrapper">
                      <div className="plm-item-detail-name circular-bold">
                        Comment
                      </div>
                      <div className="plm-item-detail-name circular-bold">
                        {item[7]}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
      </div>
    );
  }

  function forwardsMobileTable() {
    return (
      <div className="product-list-main">
        <div className="plm-item-title">
          <label className="font-weight-bold">Zone</label>
        </div>

        {searchGoogle(forwardsList).length > 0 ? (
          <div className="plm-item-wrapper" key={uuidv4()}>
            <div className="plm-item-detail-wrapper">
              <div className="plm-item-detail-name">
                {searchGoogle(forwardsList)[0][1]}
              </div>
              <div
                className="plm-item-detail-name allocate-mobile-item-detail-icon font-weight-bold"
                onClick={(e) => handleToggle(e)}
              >
                -
              </div>
            </div>
            <div className="plm-item-detail-outer-wrapper">
              <div className="plm-item-detail-wrapper">
                <div className="plm-item-detail-name circular-bold">Side</div>
                <div className="plm-item-detail-name circular-bold">
                  {searchGoogle(forwardsList)[0][0]}
                </div>
              </div>
              <div className="plm-item-detail-wrapper">
                <div className="plm-item-detail-name circular-bold">
                  Volume (ML)
                </div>
                <div className="plm-item-detail-name font-weight-bold">
                  {searchGoogle(forwardsList)[0][2]}
                </div>
              </div>
              <div className="plm-item-detail-wrapper">
                <div className="plm-item-detail-name circular-bold">
                  Delivery
                </div>
                <div className="plm-item-detail-name circular-bold">
                  {searchGoogle(forwardsList)[0][3]}
                </div>
              </div>
              <div className="plm-item-detail-wrapper">
                <div className="plm-item-detail-name circular-bold">Price</div>
                <div className="plm-item-detail-name h2o-text-bid circular-bold">
                  {searchGoogle(forwardsList)[0][4]}
                </div>
              </div>
              <div className="plm-item-detail-wrapper">
                <div className="plm-item-detail-name circular-bold">
                  Comment
                </div>
                <div className="plm-item-detail-name circular-bold">
                  {searchGoogle(forwardsList)[0][5]}
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}

        {searchGoogle(forwardsList).length > 1 &&
          searchGoogle(forwardsList)
            .slice(1)
            .map((item, id) => {
              return (
                <div className="plm-item-wrapper" key={uuidv4()}>
                  <div className="plm-item-detail-wrapper">
                    <div className="plm-item-detail-name">{item[1]}</div>
                    <div
                      className="plm-item-detail-name allocate-mobile-item-detail-icon font-weight-bold"
                      onClick={(e) => handleToggle(e)}
                    >
                      +
                    </div>
                  </div>
                  <div
                    className="plm-item-detail-outer-wrapper"
                    style={{ display: "none" }}
                  >
                    <div className="plm-item-detail-wrapper">
                      <div className="plm-item-detail-name circular-bold">
                        Side
                      </div>
                      <div className="plm-item-detail-name circular-bold">
                        {item[0]}
                      </div>
                    </div>
                    <div className="plm-item-detail-wrapper">
                      <div className="plm-item-detail-name circular-bold">
                        Volume (ML)
                      </div>
                      <div className="plm-item-detail-name circular-bold">
                        {item[2]}
                      </div>
                    </div>
                    <div className="plm-item-detail-wrapper">
                      <div className="plm-item-detail-name circular-bold">
                        Delivery
                      </div>
                      <div className="plm-item-detail-name circular-bold">
                        {item[3]}
                      </div>
                    </div>
                    <div className="plm-item-detail-wrapper">
                      <div className="plm-item-detail-name circular-bold">
                        Price
                      </div>
                      <div className="plm-item-detail-name h2o-text-bid circular-bold">
                        {item[4]}
                      </div>
                    </div>
                    <div className="plm-item-detail-wrapper">
                      <div className="plm-item-detail-name circular-bold">
                        Comment
                      </div>
                      <div className="plm-item-detail-name circular-bold">
                        {item[5]}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
      </div>
    );
  }

  function optionsMobileTable() {
    return (
      <div className="product-list-main">
        <div className="plm-item-title">
          <label className="font-weight-bold">Zone</label>
        </div>
        {searchGoogle(optionsList).length > 0 ? (
          <div className="plm-item-wrapper" key={uuidv4()}>
            <div className="plm-item-detail-wrapper">
              <div className="plm-item-detail-name">
                {searchGoogle(optionsList)[0][1]}
              </div>
              <div
                className="plm-item-detail-name allocate-mobile-item-detail-icon font-weight-bold"
                onClick={(e) => handleToggle(e)}
              >
                -
              </div>
            </div>
            <div className="plm-item-detail-outer-wrapper">
              <div className="plm-item-detail-wrapper">
                <div className="plm-item-detail-name circular-bold">Side</div>
                <div className="plm-item-detail-name circular-bold">
                  {searchGoogle(optionsList)[0][0]}
                </div>
              </div>
              <div className="plm-item-detail-wrapper">
                <div className="plm-item-detail-name circular-bold">
                  Volume (ML)
                </div>
                <div className="plm-item-detail-name circular-bold">
                  {searchGoogle(optionsList)[0][2]}
                </div>
              </div>
              <div className="plm-item-detail-wrapper">
                <div className="plm-item-detail-name circular-bold">
                  Delivery
                </div>
                <div className="plm-item-detail-name circular-bold">
                  {searchGoogle(optionsList)[0][3]}
                </div>
              </div>
              <div className="plm-item-detail-wrapper">
                <div className="plm-item-detail-name circular-bold">
                  Premium
                </div>
                <div className="plm-item-detail-name h2o-text-bid circular-bold">
                  {searchGoogle(optionsList)[0][4]}
                </div>
              </div>
              <div className="plm-item-detail-wrapper">
                <div className="plm-item-detail-name circular-bold">
                  Excercise
                </div>
                <div className="plm-item-detail-name h2o-text-bid circular-bold">
                  {searchGoogle(optionsList)[0][5]}
                </div>
              </div>
              <div className="plm-item-detail-wrapper">
                <div className="plm-item-detail-name circular-bold">
                  Comment
                </div>
                <div className="plm-item-detail-name circular-bold">
                  {searchGoogle(optionsList)[0][6]}
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}

        {searchGoogle(optionsList).length > 1 &&
          searchGoogle(optionsList)
            .slice(1)
            .map((item, id) => {
              return (
                <div className="plm-item-wrapper" key={uuidv4()}>
                  <div className="plm-item-detail-wrapper">
                    <div className="plm-item-detail-name">{item[1]}</div>
                    <div
                      className="plm-item-detail-name allocate-mobile-item-detail-icon font-weight-bold"
                      onClick={(e) => handleToggle(e)}
                    >
                      +
                    </div>
                  </div>
                  <div
                    className="plm-item-detail-outer-wrapper"
                    style={{ display: "none" }}
                  >
                    <div className="plm-item-detail-wrapper">
                      <div className="plm-item-detail-name circular-bold">
                        Side
                      </div>
                      <div className="plm-item-detail-name circular-bold">
                        {item[0]}
                      </div>
                    </div>
                    <div className="plm-item-detail-wrapper">
                      <div className="plm-item-detail-name circular-bold">
                        Volume (ML)
                      </div>
                      <div className="plm-item-detail-name circular-bold">
                        {item[2]}
                      </div>
                    </div>
                    <div className="plm-item-detail-wrapper">
                      <div className="plm-item-detail-name circular-bold">
                        Delivery
                      </div>
                      <div className="plm-item-detail-name circular-bold">
                        {item[3]}
                      </div>
                    </div>
                    <div className="plm-item-detail-wrapper">
                      <div className="plm-item-detail-name circular-bold">
                        Premium
                      </div>
                      <div className="plm-item-detail-name h2o-text-bid circular-bold">
                        {item[4]}
                      </div>
                    </div>
                    <div className="plm-item-detail-wrapper">
                      <div className="plm-item-detail-name circular-bold">
                        Excercise
                      </div>
                      <div className="plm-item-detail-name h2o-text-bid circular-bold">
                        {item[0][5]}
                      </div>
                    </div>
                    <div className="plm-item-detail-wrapper">
                      <div className="plm-item-detail-name circular-bold">
                        Comment
                      </div>
                      <div className="plm-item-detail-name circular-bold">
                        {item[6]}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
      </div>
    );
  }
}

export default Allocate;
/* eslint-enable */



// WEBPACK FOOTER //
// ./scripts/components/Allocate.js